(function () {
  const STORAGE_KEY = "sparkupQuizState";
  const RESULT_STEP = 12;
  const PROGRESS_MAX = 11;

  const QUESTIONS = {
    1: {
      id: "age",
      select: "single",
      q: "Először is: melyik korcsoportba tartozol?",
      options: [
        { value: "18–34", label: "18-34" },
        { value: "35–44", label: "35-44" },
        { value: "45–54", label: "45-54" },
        { value: "55–64", label: "55-64" },
        { value: "65+", label: "65+" }
      ]
    },
    2: {
      id: "struggle",
      select: "multi",
      q: "Mivel küzdesz a leggyakrabban?",
      sub: "Többet is választhatsz.",
      options: [
        { emoji: "⚡", value: "Low energy or an afternoon crash", label: "Alacsony energiaszint vagy délutáni lemerülés" },
        { emoji: "🌿", value: "Bloating or digestive discomfort", label: "Puffadás vagy emésztési kellemetlenség" },
        { emoji: "🌫️", value: "Brain fog or trouble focusing", label: "Agyköd vagy nehezebb fókusz" },
        { emoji: "😰", value: "Feeling wired, stressed, or restless", label: "Feszült, túlpörgött vagy nyugtalan érzés" },
        { emoji: "😴", value: "Poor sleep / waking up tired", label: "Rossz alvás / fáradt ébredés" },
        { emoji: "🌀", value: "Honestly — a bit of everything", label: "Őszintén? Egy kicsit mindegyik" }
      ]
    },
    3: {
      id: "goal",
      select: "single",
      q: "Ha egy dolgon változtathatnál a mindennapi közérzeteden, mi lenne az?",
      options: [
        { emoji: "🔋", value: "Steady energy that lasts the whole day", label: "Egyenletes energia egész nap" },
        { emoji: "🌿", value: "A calm, settled stomach", label: "Nyugodtabb, komfortosabb gyomor" },
        { emoji: "🎯", value: "Sharp focus without the fog", label: "Tiszta fókusz agyköd nélkül" },
        { emoji: "🧘", value: "Feeling calm and clear instead of wired", label: "Nyugodt, tiszta érzés túlpörgés helyett" },
        { emoji: "🌅", value: "Waking up genuinely rested", label: "Valóban kipihenten ébredni" }
      ]
    },
    5: {
      id: "coffee",
      select: "single",
      q: "Hogyan írnád le a kapcsolatodat a kávéval?",
      options: [
        { emoji: "☕", value: "One cup gets me going — I keep it simple", label: "Egy csésze elindítja a napom, ennyi elég" },
        { emoji: "☕", value: "Two cups a day, like clockwork", label: "Napi két csésze, szinte menetrend szerint" },
        { emoji: "☕", value: "Three or more — my day genuinely runs on it", label: "Három vagy több, tényleg erre épül a napom" },
        { emoji: "⚖️", value: "I've been trying to cut back, but it's hard", label: "Próbálnám csökkenteni, de nehéz" }
      ]
    },
    7: {
      id: "supplements",
      select: "multi",
      q: "A kávén kívül mit veszel még, hogy jobban érezd magad?",
      sub: "Többet is választhatsz.",
      options: [
        { emoji: "💊", value: "Vitamins or multivitamins", label: "Vitaminok vagy multivitaminok" },
        { emoji: "🌿", value: "Digestive or gut supplements", label: "Emésztést vagy bélrendszert támogató készítmények" },
        { emoji: "⚡", value: "Energy drinks or pre-workout", label: "Energiaital vagy edzés előtti pörgető" },
        { emoji: "🌙", value: "Sleep or calm aids", label: "Alvást vagy nyugalmat támogató készítmények" },
        { emoji: "☕", value: "Nothing else — just coffee", label: "Semmi mást, csak kávét" }
      ]
    },
    8: {
      id: "spend",
      select: "single",
      q: "Nagyjából mennyit költesz havonta kávéra és ezekre a plusz dolgokra együtt?",
      options: [
        { value: "Under €20", label: "8.000 Ft alatt" },
        { value: "€20–40", label: "8.000-16.000 Ft" },
        { value: "€40–70", label: "16.000-28.000 Ft" },
        { value: "€70+ — it adds up more than I'd like", label: "28.000 Ft felett - több, mint szeretném" }
      ]
    },
    10: {
      id: "commit",
      select: "single",
      q: "Utolsó kérdés. Ha egyetlen csésze egyenletes energiát adna, támogatná az emésztésedet, és kiválthatná a kávéra és kiegészítőkre költött összegek egy részét, kipróbálnád?",
      options: [
        { emoji: "✅", value: "Yes — that's exactly what I've been looking for", label: "Igen, pontosan ezt keresem" },
        { emoji: "🔍", value: "I'd want to see the proof first", label: "Előbb szeretném látni a bizonyítékokat" },
        { emoji: "🤔", value: "I'm not sure", label: "Nem vagyok benne biztos" }
      ]
    }
  };

  const RESULTS = {
    energy: {
      icon: "🔋",
      name: "Az egyenletes energia keresője",
      proof: "76,8% már 7 napon belül érezte a változást",
      body: "Nem az akaraterőd kevés, hanem az egyenletes energia. A hagyományos kávé gyors lendületet adhat, majd ugyanilyen gyors visszaesést is. A SparkUp más logikára épül: kevesebb koffein, hernyógomba a tartósabb lendületért és süngomba a fókusz támogatására. Olyan energia, ami délután sem hagy cserben."
    },
    gut: {
      icon: "🌿",
      name: "A nyugodt gyomor keresője",
      proof: "37,6% kevesebb puffadásról számolt be egy hónapon belül",
      body: "Nem kell választanod a kávé élménye és a komfortosabb gyomor között. A hagyományos kávé savassága sokaknál terhelő lehet. A SparkUp krémes, lágyabb alternatíva, amelyet úgy alakítottak ki, hogy a reggeli rituáléd finom maradjon, miközben kíméletesebb érzést ad."
    },
    wired: {
      icon: "🧘",
      name: "A túlpörgött és fáradt típus",
      proof: "89% kedvelte vagy kifejezetten szerette az ízét",
      body: "A túlpörgött, mégis fáradt állapot különösen kimerítő, és a még több koffein gyakran csak ráerősít. A SparkUp célja a nyugodtabb, tartósabb energia: kevesebb koffein, pecsétviaszgomba a kiegyensúlyozottabb alapérzet támogatására, és egy krémes kávéélmény, amit nem kell erőltetni."
    }
  };

  const INTERSTITIALS = {
    4: {
      icon: "🤝",
      title: "Nem vagy egyedül, és ezen lehet változtatni.",
      body: "A legtöbb SparkUp vásárló hasonló problémákkal érkezett: alacsony energiaszint, délutáni zuhanás, érzékenyebb gyomor, ködös fókusz. Egy hónap után sokan valódi különbséget éreztek, és 4-ből 5 vásárló ajánlaná egy barátjának.",
      pill: ["76,8%", "valódi különbséget érzett egy hónapon belül"],
      button: "Tovább"
    },
    6: {
      icon: "🤔",
      title: "Tudtad, hogy a kávéd délutánra akár ellened is dolgozhat?",
      facts: [
        ["📉", "Gyors pörgés, majd visszaesés", "A koffein gyors lendületet adhat, amit energiazuhanás követhet."],
        ["💧", "Savasság", "Érzékenyebb gyomornál kellemetlen lehet."],
        ["⏰", "5-6 óráig is dolgozhat", "Egy délutáni kávé estére is veled maradhat."]
      ],
      body: "Ez nem azt jelenti, hogy le kell mondanod a kávéról. Inkább azt, hogy érdemes olyan kávét választani, ami másképp épül fel: kevesebb koffein, lágyabb élmény, adaptogén gombákkal.",
      button: "Mutasd tovább"
    },
    9: {
      icon: "🧾",
      title: "Egy csésze sok mindent kiválthat a rutinodból.",
      tiles: [
        ["☕", "Kávé"],
        ["💊", "Kiegészítők"],
        ["⚡", "Energiaital"],
        ["🧠", "Fókusztámogatás"]
      ],
      equation: "= havonta több külön termék és kiadás",
      punchTitle: "Egy reggeli rituálé",
      punch: "A SparkUp egyetlen csészében hozza össze a kávéélményt, az egyenletesebb energiát, a fókuszt és az emésztés támogatását.",
      button: "Mutasd tovább"
    },
    11: {
      icon: "☕",
      title: "Igen, gomba van benne. Nem, nem gombaízű.",
      body: "Amit sokan csak akkor hisznek el, amikor megkóstolják: a SparkUp krémes, finom kávéélményt ad. Nem egy nehezen lenyelhető kiegészítő, hanem a reggeli kávéd, ami végre többet dolgozik érted.",
      pills: [
        ["89%", "kedvelte vagy szerette az ízét"],
        ["76,8%", "7 napon belül érezte a változást"]
      ],
      button: "Mutasd az eredményem"
    }
  };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function icon(name) {
    const icons = {
      arrow: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 12h13m-5-5 5 5-5 5"/></svg>',
      check: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="m5 13 4 4L19 7"/></svg>',
      gift: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M20 12v8H4v-8m18-5H2v5h20V7ZM12 22V7m0 0H7.5A2.5 2.5 0 1 1 10 4.5C10 6 12 7 12 7Zm0 0h4.5A2.5 2.5 0 1 0 14 4.5C14 6 12 7 12 7Z"/></svg>',
      clock: '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
      shield: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 3 5 6v5c0 5 3 8 7 10 4-2 7-5 7-10V6l-7-3Z"/><path d="m8.5 12 2.2 2.2L15.8 9"/></svg>',
      spark: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Zm6 11 .8 2.2L21 17l-2.2.8L18 20l-.8-2.2L15 17l2.2-.8L18 14Z"/></svg>',
      restart: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 12a8 8 0 1 0 2.3-5.7L4 8.6"/><path d="M4 4v4.6h4.6"/></svg>'
    };

    return icons[name] || "";
  }

  function computeResult(answers) {
    const goal = answers.goal;
    const struggles = answers.struggle || [];

    if (goal === "A calm, settled stomach") return "gut";
    if (goal === "Feeling calm and clear instead of wired" || goal === "Waking up genuinely rested") return "wired";
    if (!goal && struggles.includes("Bloating or digestive discomfort")) return "gut";
    if (!goal && (
      struggles.includes("Feeling wired, stressed, or restless") ||
      struggles.includes("Poor sleep / waking up tired") ||
      struggles.includes("Honestly — a bit of everything")
    )) return "wired";

    return "energy";
  }

  function createQuiz(root) {
    let saved = {};

    try {
      saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    } catch (error) {
      saved = {};
    }

    const state = {
      step: Number.isInteger(saved.step) ? Math.min(Math.max(saved.step, 0), RESULT_STEP) : 0,
      answers: saved.answers && typeof saved.answers === "object" ? saved.answers : {},
      displayedAnswers: saved.displayedAnswers && typeof saved.displayedAnswers === "object" ? saved.displayedAnswers : {},
      locked: false,
      customerCount: root.dataset.customerCount || "60,000",
      surveyCount: root.dataset.surveyCount || "984",
      productUrl: root.dataset.productUrl || "/products/kulonleges-gomba-kave",
      productTitle: root.dataset.productTitle || "SparkUp™ - Gombakávé",
      productImage: root.dataset.productImage || "",
      variantId: root.dataset.variantId || ""
    };

    const body = root.querySelector(".sparkup-quiz__body");
    const progress = root.querySelector(".sparkup-quiz__progress");
    const fill = root.querySelector(".sparkup-quiz__fill");
    const stepText = root.querySelector(".sparkup-quiz__step");
    const back = root.querySelector(".sparkup-quiz__back");

    function platformEventName(eventName) {
      const names = {
        sparkup_quiz_started: "QuizStarted",
        sparkup_quiz_step_view: "QuizStepViewed",
        sparkup_quiz_answer: "QuizAnswerSubmitted",
        sparkup_quiz_result_view: "QuizCompleted",
        sparkup_quiz_pdp_click: "QuizPdpClicked",
        sparkup_quiz_restart: "QuizRestarted"
      };

      return names[eventName] || eventName;
    }

    function track(eventName, detail) {
      const resultType = state.step === RESULT_STEP ? computeResult(state.answers) : undefined;
      const payload = Object.assign({
        event: eventName,
        event_id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        platform_event: platformEventName(eventName),
        step: state.step,
        result_type: resultType,
        answers: state.answers,
        displayed_answers: state.displayedAnswers
      }, detail || {});

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);

      try {
        if (typeof window.fbq === "function") {
          window.fbq("trackCustom", payload.platform_event, payload, { eventID: payload.event_id });
        }
      } catch (error) {}

      try {
        if (typeof window.gtag === "function") {
          window.gtag("event", payload.platform_event, payload);
        }
      } catch (error) {}

      try {
        if (window._learnq && typeof window._learnq.push === "function") {
          window._learnq.push(["track", payload.platform_event, payload]);
        }
      } catch (error) {}

      try {
        if (window.klaviyo && typeof window.klaviyo.push === "function") {
          window.klaviyo.push(["track", payload.platform_event, payload]);
        }
      } catch (error) {}

      try {
        if (typeof window.TriplePixel === "function") {
          window.TriplePixel("custom", payload.platform_event, payload);
        }
      } catch (error) {}

      root.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: payload }));
    }

    function persist() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          step: state.step,
          answers: state.answers,
          displayedAnswers: state.displayedAnswers
        }));
      } catch (error) {
        // Storage can fail in private browsing; the quiz should still work.
      }
    }

    function next() {
      if (state.step < RESULT_STEP) {
        if (state.step === 0) track("sparkup_quiz_started");
        state.step += 1;
        render();
      }
    }

    function previous() {
      if (state.step > 0) {
        state.step -= 1;
        state.locked = false;
        track("sparkup_quiz_back");
        render();
      }
    }

    function restart() {
      state.step = 0;
      state.answers = {};
      state.displayedAnswers = {};
      state.locked = false;
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (error) {}
      track("sparkup_quiz_restart");
      render();
    }

    function pick(questionId, value, label, select) {
      if (select === "multi") {
        const selected = state.answers[questionId] || [];
        const displayed = state.displayedAnswers[questionId] || [];
        const exists = selected.includes(value);
        state.answers[questionId] = exists ? selected.filter((item) => item !== value) : selected.concat(value);
        state.displayedAnswers[questionId] = exists ? displayed.filter((item) => item !== label) : displayed.concat(label);
        track("sparkup_quiz_answer", { questionId, answer: value, displayedAnswer: label, select, selected: state.answers[questionId] });
        render();
        return;
      }

      if (state.locked) return;
      state.locked = true;
      state.answers[questionId] = value;
      state.displayedAnswers[questionId] = label;
      track("sparkup_quiz_answer", { questionId, answer: value, displayedAnswer: label, select });

      window.setTimeout(() => {
        state.locked = false;
        next();
      }, 140);
    }

    function renderEntry() {
      const introImage = state.productImage ? `
        <figure class="sparkup-quiz__intro-image">
          <img src="${escapeHtml(state.productImage)}" alt="${escapeHtml(state.productTitle)}" loading="eager">
        </figure>
      ` : "";

      return `
        <div class="sparkup-quiz__cup" aria-hidden="true">
          <svg viewBox="0 0 62 62">
            <g class="sparkup-quiz__steam">
              <path d="M24 17c-3-3 3-6 0-10" />
              <path d="M31 17c-3-3 3-6 0-10" />
              <path d="M38 17c-3-3 3-6 0-10" />
            </g>
            <path d="M14 25h30v13a13 13 0 0 1-13 13h-4a13 13 0 0 1-13-13z" />
            <path d="M44 28h4a6 6 0 0 1 0 12h-4" />
            <ellipse cx="29" cy="25" rx="15" ry="4.6" />
          </svg>
        </div>
        <p class="sparkup-quiz__eyebrow">60 másodperces energia teszt</p>
        <h1 class="sparkup-quiz__title sparkup-quiz__title--large" tabindex="-1">A kávéd sokkal többet is tehetne érted.</h1>
        <p class="sparkup-quiz__text">Derítsd ki, mi szívja le csendben az energiádat, és milyen reggeli rutint választott már ${escapeHtml(state.customerCount)}+ magyar vásárló.</p>
        <div class="sparkup-quiz__stars" aria-label="4,85 átlagos értékelés">
          <span aria-hidden="true">★★★★★</span>
          <span>4,85 átlag · ${escapeHtml(state.customerCount)}+ vásárló</span>
        </div>
        ${introImage}
        <div class="sparkup-quiz__actions">
          <button class="sparkup-quiz__button" type="button" data-action="next">Teszt indítása ${icon("arrow")}</button>
          <p class="sparkup-quiz__fine">${escapeHtml(state.surveyCount)} SparkUp vásárló visszajelzése alapján.</p>
        </div>
      `;
    }

    function renderQuestion(question) {
      const value = state.answers[question.id];
      const selected = question.select === "multi" ? value || [] : value;
      const canContinue = question.select === "multi" && selected.length > 0;
      const groupRole = question.select === "single" ? "radiogroup" : "group";
      const optionRole = question.select === "single" ? "radio" : "checkbox";
      const options = question.options.map((option, index) => {
        const isSelected = question.select === "multi" ? selected.includes(option.value) : selected === option.value;
        return `
          <button class="sparkup-quiz__option${isSelected ? " is-selected" : ""}" type="button" role="${optionRole}" aria-checked="${isSelected ? "true" : "false"}"
            style="--delay: ${index * 0.04}s"
            data-action="pick"
            data-question="${escapeHtml(question.id)}"
            data-select="${escapeHtml(question.select)}"
            data-value="${escapeHtml(option.value)}"
            data-label="${escapeHtml(option.label)}">
            ${option.emoji ? `<span class="sparkup-quiz__emoji">${option.emoji}</span>` : ""}
            <span class="sparkup-quiz__option-label">${escapeHtml(option.label)}</span>
            <span class="sparkup-quiz__tick">${isSelected ? icon("check") : ""}</span>
          </button>
        `;
      }).join("");

      return `
        <h1 class="sparkup-quiz__title" id="sparkup-question-${state.step}" tabindex="-1">${escapeHtml(question.q)}</h1>
        ${question.sub ? `<p class="sparkup-quiz__text">${escapeHtml(question.sub)}</p>` : ""}
        <div class="sparkup-quiz__options" role="${groupRole}" aria-labelledby="sparkup-question-${state.step}">${options}</div>
        ${question.select === "multi" ? `
          <div class="sparkup-quiz__actions">
            <button class="sparkup-quiz__button" type="button" data-action="next" ${canContinue ? "" : "disabled"}>Tovább ${icon("arrow")}</button>
          </div>
        ` : ""}
      `;
    }

    function renderInterstitial(data) {
      const facts = data.facts ? `
        <div class="sparkup-quiz__facts">
          ${data.facts.map((fact, index) => `
            <div class="sparkup-quiz__fact" style="--delay: ${index * 0.06}s">
              <span>${fact[0]}</span>
              <div><b>${escapeHtml(fact[1])}</b><p>${escapeHtml(fact[2])}</p></div>
            </div>
          `).join("")}
        </div>
      ` : "";

      const tiles = data.tiles ? `
        <div class="sparkup-quiz__tiles">
          ${data.tiles.map((tile, index) => `
            <div class="sparkup-quiz__tile" style="--delay: ${index * 0.06}s">
              <span>${tile[0]}</span>
              <p>${escapeHtml(tile[1])}</p>
            </div>
          `).join("")}
        </div>
        <p class="sparkup-quiz__equation">${escapeHtml(data.equation)}</p>
        <div class="sparkup-quiz__punch">
          <b>${escapeHtml(data.punchTitle)}</b>
          <p>${escapeHtml(data.punch)}</p>
        </div>
      ` : "";

      const pill = data.pill ? `<div class="sparkup-quiz__pill"><b>${escapeHtml(data.pill[0])}</b><span>${escapeHtml(data.pill[1])}</span></div>` : "";
      const pills = data.pills ? `<div class="sparkup-quiz__pills">${data.pills.map((item) => `<div class="sparkup-quiz__pill"><b>${escapeHtml(item[0])}</b><span>${escapeHtml(item[1])}</span></div>`).join("")}</div>` : "";

      return `
        <div class="sparkup-quiz__interstitial-icon">${data.icon}</div>
        <h1 class="sparkup-quiz__title" tabindex="-1">${escapeHtml(data.title)}</h1>
        ${data.body ? `<p class="sparkup-quiz__interstitial-text">${escapeHtml(data.body)}</p>` : ""}
        ${facts}
        ${tiles}
        ${pill}
        ${pills}
        <div class="sparkup-quiz__actions">
          <button class="sparkup-quiz__button" type="button" data-action="next">${escapeHtml(data.button)} ${icon("arrow")}</button>
        </div>
      `;
    }

    function renderResult() {
      const key = computeResult(state.answers);
      const result = RESULTS[key];
      const struggles = state.displayedAnswers.struggle || [];
      const gift = [
        ["Kézzel készített fa kanál", "1.490 Ft"],
        ["Prémium bambusz termosz /450 ml/", "7.990 Ft"],
        ["Prémium habosító", "5.990 Ft"],
        ["Akácfa tárolóedény", "9.990 Ft"]
      ];
      const goal = state.displayedAnswers.goal ? `
        <div class="sparkup-quiz__echo">
          A legfontosabb célod: <b>${escapeHtml(String(state.displayedAnswers.goal).toLowerCase())}</b>${struggles.length ? ` — miközben ${struggles.length} mindennapi kihívással is küzdesz.` : "."}
        </div>
      ` : "";

      return `
        <div class="sparkup-quiz__result-badge">${icon("spark")} Eredményed</div>
        <div class="sparkup-quiz__result-type">
          <span>${result.icon}</span>
          <h1 tabindex="-1">${escapeHtml(result.name)}</h1>
        </div>
        ${goal}
        <p class="sparkup-quiz__readback">${escapeHtml(result.body)}</p>
        <div class="sparkup-quiz__welcome">${escapeHtml(result.proof)}</div>
        <div class="sparkup-quiz__product${state.productImage ? "" : " sparkup-quiz__product--no-image"}">
          ${state.productImage ? `<img src="${escapeHtml(state.productImage)}" alt="${escapeHtml(state.productTitle)}" loading="lazy">` : ""}
          <div>
            <p class="sparkup-quiz__product-kicker">Ajánlott következő lépés</p>
            <h2>${escapeHtml(state.productTitle)}</h2>
          </div>
        </div>
        <div class="sparkup-quiz__gift">
          <h2>${icon("gift")} Ajándékok a 3+2 csomagodhoz</h2>
          ${gift.map((item) => `
            <div class="sparkup-quiz__gift-row">
              <span class="sparkup-quiz__gift-dot"></span>
              <span>${escapeHtml(item[0])}</span>
              <s>${escapeHtml(item[1])}</s>
              <b>AJÁNDÉK</b>
            </div>
          `).join("")}
        </div>
        <div class="sparkup-quiz__urgency">${icon("clock")} A kedvezményes 3+2 ajánlat most elérhető</div>
        <div class="sparkup-quiz__guarantee">${icon("shield")} 60 napos pénzvisszafizetési garancia.</div>
        <div class="sparkup-quiz__actions">
          <a class="sparkup-quiz__button" href="${escapeHtml(state.productUrl)}" data-action="pdp-click">Megnézem a SparkUp-ot ${icon("arrow")}</a>
          <button class="sparkup-quiz__restart" type="button" data-action="restart">${icon("restart")} Újrakezdem a tesztet</button>
        </div>
      `;
    }

    function renderScreen() {
      if (state.step === 0) return renderEntry();
      if (QUESTIONS[state.step]) return renderQuestion(QUESTIONS[state.step]);
      if (INTERSTITIALS[state.step]) return renderInterstitial(INTERSTITIALS[state.step]);
      if (state.step === RESULT_STEP) return renderResult();
      return "";
    }

    function render() {
      progress.hidden = state.step === 0 || state.step === RESULT_STEP;
      back.disabled = state.step === 0;
      const progressValue = Math.min(state.step, PROGRESS_MAX) / PROGRESS_MAX * 100;
      fill.style.width = `${progressValue}%`;
      stepText.textContent = `${Math.min(Math.max(state.step, 1), PROGRESS_MAX)}/${PROGRESS_MAX}`;
      progress.setAttribute("role", "progressbar");
      progress.setAttribute("aria-valuemin", "0");
      progress.setAttribute("aria-valuemax", String(PROGRESS_MAX));
      progress.setAttribute("aria-valuenow", String(Math.min(state.step, PROGRESS_MAX)));
      progress.setAttribute("aria-label", "Kvíz előrehaladása");
      body.innerHTML = `<div class="sparkup-quiz__pad">${renderScreen()}</div>`;
      body.scrollTop = 0;
      persist();
      track(state.step === RESULT_STEP ? "sparkup_quiz_result_view" : "sparkup_quiz_step_view");

      window.setTimeout(() => {
        const heading = body.querySelector("h1");
        if (heading) heading.focus({ preventScroll: true });
      }, 0);
    }

    back.addEventListener("click", previous);

    body.addEventListener("click", (event) => {
      const target = event.target.closest("[data-action]");
      if (!target) return;

      const action = target.dataset.action;
      if (action === "next") next();
      if (action === "restart") restart();
      if (action === "pick") pick(target.dataset.question, target.dataset.value, target.dataset.label, target.dataset.select);
      if (action === "pdp-click") track("sparkup_quiz_pdp_click", { href: target.getAttribute("href") });
    });

    render();
  }

  document.querySelectorAll("[data-sparkup-quiz]").forEach(createQuiz);
})();
